export default __webpack_public_path__ + "static/media/watchdog-4.9be82ce1.png";